module.exports = __webpack_public_path__ + "img/e_2_2_r.8cf529e5.png";